import Client from './client';

export default class Ciphers extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/cipher`, {
      ...options,
       method: 'POST',
    });
  }

  postGet(options = {}) {
    return this.makeRequest(`${this.host}/internal/cipher/get`, {
      ...options,
       method: 'POST',
    });
  }

}
